import { Injectable } from '@angular/core';
import {ConfiguracionTarjetaResource} from './configuracion-tarjeta.resource';
import {ConfiguracionTarjetaModel} from './configuracion-tarjeta.model';
import { ConfiguracionTarjetaTpvModel } from './configuracion-tarjeta-tpv.model';
// import {ConfiguracionTarjetaTiaModel} from './configuracion-tarjeta-tia.model';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionTarjetaService {

  constructor(private configuracionTarjetaResource: ConfiguracionTarjetaResource) { }

  obtenerConfiguracionTarjeta(): Promise<ConfiguracionTarjetaModel> {
    return this.configuracionTarjetaResource.obtenerConfiguracionTarjetaTia();
  }

  actualizarConfiguracionTarjeta(configuracion: ConfiguracionTarjetaModel): Promise<any> {
    return this.configuracionTarjetaResource.actualizarConfiguracionTarjetaTia(configuracion);
  }

   /* TARJETAS TPV */

   obtenerConfiguracionTarjetaTpv(): Promise<ConfiguracionTarjetaTpvModel> {
    return this.configuracionTarjetaResource.obtenerConfiguracionTarjetaTpv();
  }


  actualizarConfiguracionTarjetaTpv(configuracion: ConfiguracionTarjetaTpvModel): Promise<any>{
    return this.configuracionTarjetaResource.actualizarConfiguracionTarjetaTpv(configuracion);
  }

  // obtenerConfiguracionTarjetaTia(): Promise<ConfiguracionTarjetaTiaModel> {
  //   return this.configuracionGeneralResource.obtenerConfiguracionTarjetaTia();
  // }

  

}
